import React from 'react';
import { withAuth } from '@cdk-prod/fortellis-auth-context';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import FortellisConstants from '../common/FortellisConstants';
import {
  Card,
  ListWrapper,
  ListItem,
  ListItemGraphic,
  TextButton,
  IconArrowForward,
  Button,
  BUTTON_VARIANTS
} from 'cdk-radial';
import IconCheckCircleLogo from '../common/images/IconCheckCircle.jpg';
import { sendAmplitudeData } from '../../utils/amplitude';
import {
  AMPLITUDE_EVENTS,
  AMPLITUDE_PROPERTIES
} from '../../utils/amplitude-constants';
import { environmentURLs } from '../common/environment/CaptureEnvironment';

class PlanFeatures extends React.Component {
  redirectToDealerSuiteSolution = () => {
    const {
      solution: { id: solutionId } = {},
      plan: { id: planId } = {},
      solution,
      plan,
      entity
    } = this.props;

    sendAmplitudeData(AMPLITUDE_EVENTS.SUBSCRIBE_TO_APP_PLAN, {
      [AMPLITUDE_PROPERTIES.APP_ID]: solutionId,
      [AMPLITUDE_PROPERTIES.APP_NAME]: solution.overview.name,
      [AMPLITUDE_PROPERTIES.PRICING_PLAN_ID]: plan.id,
      [AMPLITUDE_PROPERTIES.PRICING_PLAN_NAME]: plan.planName,
      [AMPLITUDE_PROPERTIES.ORG_ID]: entity && entity.id ? entity.id : 'NA',
      [AMPLITUDE_PROPERTIES.ORG_NAME]:
        entity && entity.name ? entity.name : 'NA'
    });

    const url = `${environmentURLs.dealerSuiteLogin}/${solutionId}/${planId}`;
    window.open(url, '_blank');
  };

  render() {
    const {
      intl,
      plan,
      solution,
      existingSubscriptionByEntity,
      isPreview,
      entity,
      auth: { isAuthenticated },
      showSubscribeButton
    } = this.props;
    return (
      <div>
        <Card className="purchase-sol__card">
          <div className="editionFea__name">{plan.planName}</div>
          <div className="editionFea__Price">
            {plan.billingType === 'TRANSACTIONAL'
              ? plan.includedTransactionalFee
                ? plan.transactionalTypeOptions === '$'
                  ? `${plan.transactionalTypeOptions}${
                      plan.includedTransactionalFee
                    }${plan.includedTransactionalFee % 1 === 0 ? `.00` : ''}`
                  : `${plan.includedTransactionalFee}${
                      plan.transactionalTypeOptions
                    }`
                : null
              : plan.basePrice ||
                (plan.isTheFreeTrial && plan.isFreeTrialEnabled) ||
                plan.billingType === 'FREE'
              ? `$${plan.basePrice ? plan.basePrice : '0'}${
                  plan.basePrice % 1 === 0 ? `.00` : ''
                }`
              : null}
            {plan.isTheFreeTrial && plan.isFreeTrialEnabled ? (
              plan.freeTrialPeriod ? (
                <span className="editionFea__freeTrial">
                  <br /> Try {plan.freeTrialPeriod} {plan.freeTrialPeriodType}{' '}
                  Free
                </span>
              ) : null
            ) : plan.basePrice ||
              (plan.isTheFreeTrial && plan.isFreeTrialEnabled) ||
              plan.includedTransactionalFee ? (
              <span className="editionFea__frequency">
                {plan.billingType === 'TRANSACTIONAL' ? (
                  plan.includedTransactionalType ? (
                    `/${plan.includedTransactionalType}`
                  ) : null
                ) : plan.billingType.toLowerCase() === 'one time' ? (
                  <span>
                    <br /> One Time Fee{' '}
                  </span>
                ) : (
                  `/${plan.billingFrequency.toLowerCase()}`
                )}
                <br />{' '}
              </span>
            ) : null}
          </div>

          {plan.includedUnitQuantity &&
            plan.includedUnitOfMeasure &&
            plan.billingType !== 'TRANSACTIONAL' && (
              <div className="editionFea__details">
                <span className="edition-features__subheading">
                  <FormattedHTMLMessage
                    id="EditionFeatures.span"
                    defaultMessage="Includes up to "
                  />
                  {plan.includedUnitQuantity} {plan.includedUnitOfMeasure}
                </span>
                <br />
              </div>
            )}

          {solution &&
            solution.solutionType !== FortellisConstants.PARTNER_PROGRAM && (
              <Button
                variant={BUTTON_VARIANTS.PRIMARY}
                raised={true}
                dataTestId="subscribeButton"
                className="subscribe-button"
                isDisabled={isPreview}
                onClick={this.redirectToDealerSuiteSolution}
                text="Subscribe"
              />
            )}
          {plan.features && plan.features.length ? (
            <div>
              <span className="edition-feature_sub-heading">
                Included Features
              </span>
              <ListWrapper className="plans-and-pricing-feature-list">
                {plan.features &&
                  plan.features.map(feature => (
                    <ListItem
                      key={feature.id}
                      className="edition-feature__lists"
                    >
                      <ListItemGraphic>
                        <img
                          src={IconCheckCircleLogo}
                          alt={intl.formatMessage({
                            id: 'EditionFeatures.checkIcon.alt',
                            defaultMessage: 'check'
                          })}
                          style={{ width: '25px', height: '25px' }}
                        />
                      </ListItemGraphic>
                      {feature.title}
                    </ListItem>
                  ))}
              </ListWrapper>
              <ListItem className="view-feature-details">
                <TextButton
                  dataTestId="view-more"
                  onClick={() => {
                    this.props.tabSelect(0);
                  }}
                  text={'Features Details'}
                />
                <IconArrowForward
                  style={{ fill: '#6b2673', cursor: 'pointer' }}
                  onClick={() => {
                    this.props.tabSelect(0);
                  }}
                />
              </ListItem>
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default injectIntl(withAuth(PlanFeatures));
